$(document).ready(function() {
  var pickupLabel = "Pick-Up at Ottawa Bayshore Store?"; // the text of the label
  var buttonArea = $('.cart .cart__additional_checkout'); // where to insert the option
  var pickupVariantIdBayshore = 32888716951636; // the variant ID of the local pickup product

  Shopify.getCart(function(cart) {
    var inCartBayshore = false;
    $.each(cart.items, function(index, item) {
      if (item.variant_id == pickupVariantIdBayshore) {
        inCartBayshore = true;
        return false;
      }
    });
    buttonArea.append('<div style="text-align: left; margin-top: 15px;"><label for="local-pickup-bayshore" style="padding: 5px; border: 1px solid #000;"><input id="local-pickup-bayshore" type="checkbox"' + (inCartBayshore ? ' checked' : '') + ' /> ' + pickupLabel + '</label></div>');
  });

  buttonArea.on('change', '#local-pickup-bayshore', function() {
    if ($(this).is(':checked')) {
      Shopify.addItem(pickupVariantIdBayshore, 1, function(item) {
        location.reload();
      });
    } else {
      Shopify.changeItem(pickupVariantIdBayshore, 0, function(cart) {
        location.reload();
      });
    }
  });

});